import axios from 'axios';
import { CommonApiOptions, METHOD_TYPE } from '../constants/api';
import configs from '../configs/apiConfigs';
import { attachHeader } from '../utils/apiHandler';
import { commonApi } from '../helpers/api';

interface NewPatient {
  id: number;
  name: string;
  date: string;
  source: string;
  hasRecording: boolean;
  value: number;
}

interface PatientFollowUpResponse {
  data: NewPatient[];
}



export const fetchPatientToCallBack = (params: any) => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}patient-follow-up/${params.clinicUniqueId}/?startDate=${params.startDate}&endDate=${params.endDate}`,
    method: METHOD_TYPE.GET,

    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
    // body: {
    //   type: BODY_TYPE.RAW,
    //   data: params
    // }
  };
  return commonApi(request);
};
